import { CreditCard, Droplets } from "lucide-react";
import { publishedRates } from "@/data/resort";
import { Reveal } from "../reveal";

export function PaymentAndDumping() {
  return (
    <section
      id="policies"
      aria-labelledby="payment-heading"
      className="bg-secondary/40 py-14 md:py-16"
    >
      <div className="shell grid gap-6 lg:grid-cols-2">
        <Reveal>
          <article className="h-full border border-border bg-background p-8 md:p-10">
            <div className="flex items-center gap-4">
              <span className="flex size-12 items-center justify-center rounded-full border border-border bg-secondary/50 text-primary">
                <CreditCard className="size-5" strokeWidth={1.5} aria-hidden="true" />
              </span>
              <h2 id="payment-heading" className="display-md">
                Payment Methods
              </h2>
            </div>
            <p className="mt-6 text-base leading-relaxed text-muted-foreground">
              Credit card payments are accepted using:
            </p>
            <ul className="mt-6 flex flex-wrap gap-3" aria-label="Accepted credit cards">
              {publishedRates.paymentMethods.map((method) => (
                <li
                  key={method}
                  className="eyebrow border border-border bg-secondary/40 px-5 py-3 text-foreground"
                >
                  {method}
                </li>
              ))}
            </ul>
          </article>
        </Reveal>

        <Reveal delay={0.08}>
          <article className="h-full border border-border bg-background p-8 md:p-10">
            <div className="flex items-center gap-4">
              <span className="flex size-12 items-center justify-center rounded-full border border-border bg-secondary/50 text-primary">
                <Droplets className="size-5" strokeWidth={1.5} aria-hidden="true" />
              </span>
              <h2 className="display-md">On-Site Dumping Facility</h2>
            </div>
            <p className="mt-6 text-base leading-relaxed text-muted-foreground">
              The on-site sewer dumping facility is available exclusively for registered Auburn RV
              Resort guests. Public dumping is not available.
            </p>
          </article>
        </Reveal>
      </div>
    </section>
  );
}
